const RecommendedCoursesSkeleton = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="h-6 w-64 bg-gray-200 mx-auto rounded animate-pulse mb-4" />
          <div className="h-4 w-96 bg-gray-100 mx-auto rounded animate-pulse" />
        </div>

        <div className="flex gap-6 overflow-x-auto">
          {[...Array(5)].map((_, index) => (
            <div
              key={index}
              className="w-80 flex-shrink-0 bg-white rounded-2xl shadow-md overflow-hidden animate-pulse"
            >
              <div className="h-48 bg-gray-200 w-full" />

              <div className="p-5 flex flex-col gap-3">
                <div className="h-4 bg-gray-300 rounded w-3/4" />
                <div className="h-3 bg-gray-200 rounded w-full" />
                <div className="h-3 bg-gray-200 rounded w-5/6" />

                <div className="flex justify-between mt-2">
                  <div className="h-3 w-20 bg-gray-200 rounded" />
                  <div className="h-3 w-10 bg-gray-200 rounded" />
                </div>

                <div className="flex justify-between items-center mt-auto">
                  <div className="h-5 w-16 bg-gray-300 rounded" />
                  <div className="h-8 w-20 bg-gray-300 rounded" />
                </div>
              </div>
            </div>
          ))}

          {/* Show More Placeholder */}
          <div className="w-80 flex-shrink-0 flex justify-center items-center border-2 border-dashed border-gray-300 rounded-2xl animate-pulse">
            <div className="flex flex-col items-center">
              <div className="h-6 w-6 bg-gray-300 rounded-full mb-2" />
              <div className="h-3 w-20 bg-gray-200 rounded" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecommendedCoursesSkeleton;
